import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import Span from '../dev/Span'
import CheckIcon from '../icon/CheckIcon2'
import StyleLink from '../dev/StyleLink'

const ChannelList = (props) => {
    const { selectCreator, exsitedCreators, messages, plan, auth, infoList: { channelSortCategory}, isInfoListTourActive } = props
    let { channelList, selectedCreators } = props
    if (plan!=='Agency' && plan!=='Brand' && !isInfoListTourActive) /*如果不是 B 或 A 就用假資料+上模糊遮罩*/ 
        channelList = fakedata ;
    return (
        <div>{channelList.map((channel, index) => {
            const { id, avatar, title, country, channelType, videoCount, subscriberCount,
                monthSubscriberCount, monthSubscriberRate, monthViewCount, monthViewRate,
                recentAvgViewCount, recentAvgEngageRate
            } = channel
            const isCheck = selectedCreators.concat(exsitedCreators).find(i => i.id === id) !== undefined
            //篩選此channel有沒有在選擇的名單中
            const isMask = plan !== "Agency" && plan !== "Brand" && !isInfoListTourActive
            return (
                    <ChannelWrap >
                        <ChannelSelectButton 
                            id={isInfoListTourActive && index === 0 && "user_tour_infolist_3"}
                            onClick={() => selectCreator(id)} 
                            backgroundColor={isCheck ? '#f5b4b4' : '#ebebeb'}
                        >
                            <CheckIcon color={isCheck ? '#fff' :'#a0a0a0'}/>
                        </ChannelSelectButton>
                        <MaskWrap isMask={isMask}>
                            <StyleLink to={`/Info/${channel.id}`} target={'_blank'}>                   
                                <ChannelAvatar avatar={avatar} />
                            </StyleLink>
                        </MaskWrap>
                        <ChannelInfoWrap>
                            <MaskWrap isMask={isMask}>
                                <StyleLink to={`/Info/${channel.id}`} target={'_blank'}>      
                                    <ChannelTitle language={messages.localeLanguage !== 'zh'}>{title}</ChannelTitle>
                                </StyleLink>
                            </MaskWrap>
                            {messages.localeLanguage !== 'zh' && 
                                <ChannelInfo language>
                                    <Info language>
                                    </Info>
                                    <Month language>{messages.monthly}</Month>
                                    <Recent language>{messages.the_avg_of_recent_videos}</Recent>
                                </ChannelInfo>}
                            <ChannelInfo>
                                <Info>
                                    <div >
                                        <Span>{messages.country}</Span>
                                        <Span>{messages.channelType}</Span>
                                        <Span>{messages.info_total_videos}</Span>
                                        <Span highlight={channelSortCategory === '' || channelSortCategory === '訂閱數'}>{messages.info_subscribers}</Span>
                                    </div>
                                    <MaskWrap isMask={isMask}>
                                            <Span>{country || 'N/A'}</Span>
                                            <Span>{channelType || 'N/A'}</Span>
                                            <Span>{videoCount}</Span>
                                            <Span highlight={channelSortCategory === '' || channelSortCategory ==='訂閱數'}>{subscriberCount}</Span>
                                    </MaskWrap>
                                </Info>
                                <Month>
                                    <div>
                                        <Span highlight={channelSortCategory === '月訂閱數'}>{messages.infoList_monthly_subscribers}</Span>
                                        <Span highlight={channelSortCategory === '月訂閱成長率'}>{messages.infoList_monthly_subscriptions_growth}</Span>
                                        <Span highlight={channelSortCategory === '月觀看數'}>{messages.infoList_monthly_views}</Span>
                                        <Span highlight={channelSortCategory === '月觀看成長率'}>{messages.infoList_monthly_views_growth}</Span>
                                    </div>
                                    <MaskWrap isMask={isMask}>
                                        <Span highlight={channelSortCategory === '月訂閱數'}>{monthSubscriberCount}</Span>
                                        <Span highlight={channelSortCategory === '月訂閱成長率'}>{monthSubscriberRate}%</Span>
                                        <Span highlight={channelSortCategory === '月觀看數'}>{monthViewCount}</Span>
                                        <Span highlight={channelSortCategory === '月觀看成長率'}>{monthViewRate}%</Span>
                                    </MaskWrap>
                                </Month>
                                <Recent>
                                    <div>
                                        <Span highlight={channelSortCategory === '近20支平均觀看數'}>{messages['infoList_20_avg_views']}</Span>
                                        <Span highlight={channelSortCategory === '近20支平均互動率'}>{messages['infoList_20_avg_engage']}</Span>
                                    </div>
                                    <MaskWrap isMask={isMask}>
                                        <Span highlight={channelSortCategory === '近20支平均觀看數'}>{recentAvgViewCount}</Span>
                                        <Span highlight={channelSortCategory === '近20支平均互動率'}>{recentAvgEngageRate}%</Span>
                                    </MaskWrap>
                                </Recent>
                            </ChannelInfo>
                        </ChannelInfoWrap>
                    </ChannelWrap>
            )
        })}</div>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
        infoList: state.InfoList,
        payment: state.Payment,
    }
}
export default connect(mapStateToProps)(ChannelList);

const ChannelWrap =styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 900px;
    height: 160px;
    margin-bottom: 10px;
    background-color: #fff;
`
const ChannelSelectButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 100%;
    margin-right: 20px;
    background-color: ${({backgroundColor}) => backgroundColor };
    cursor: pointer;
`
const ChannelAvatar = styled.div`
    width: 120px;
    height: 120px;
    margin: 20px 20px 20px 0;/* 防左margin被點擊 */
    background: url('${props => props.avatar}');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
`
const ChannelInfoWrap = styled.div`
    display: flex;
    flex-direction: column;
`
const ChannelTitle = styled.div`
    font-weight: 500;
    font-size: 1rem;
    color: #666666;
    ${({ language }) => language ? '' : 'margin-bottom: 20px;'};    
`
const ChannelInfo = styled.div`
    display: flex;
    font-weight: 300;
    font-size: .6rem;
    color: #787878;
    ${({ language }) => language ? 'margin-bottom: 8px;' : ''};    
`
const Info = styled.div`
    display: flex;
    width: 220px;
    ${({ language }) => language ? '' : 'border-right: .5px solid #999999;'};
    div {
        display: flex;
        flex-direction: column;
    }
    div:first-child {
        margin-right: 20px;
    }
`
const Month = styled.div`
    display: flex;
    ${({ language }) => language 
        ? 'align-items: center; color: #666; font-weight: 500;' 
        : 'border-right: .5px solid #999999;'};
    width: 250px;
    padding: 0 10px;
    div {
        display: flex;
        flex-direction: column;
    }
    div:first-child {
        margin-right: 10px;
    }
`
const Recent = styled.div`
    display: flex;
    ${({ language }) => language
    ? 'align-items: center; color: #666; font-weight: 500;'
        : ''};
    width: 250px;
    padding: 0 0 0 20px;
    div {
        display: flex;
        flex-direction: column;
    }
    div:first-child {
        margin-right: 10px;
    }
    div:last-child {
        font-weight: 500;
    }
`
const MaskWrap = styled.div`
    ${({ isMask }) => isMask ? 'filter: blur(5px)' : ''};
`
const Edit = styled.div`
    display: flex;
    justify-content: center;
    text-align: center;
    min-width: 80px;
    margin-top: 6px;
    padding: 0 8px;
    color: #fff;
    font-size: 16px;
    background-color: #e94242;
    opacity: .8;
    box-shadow: 1px 2px 2px 0 rgba(153, 153, 153, 0.6);
    cursor: pointer;
`
const fakedata= [
    {
        "id": 1086,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAztY6oYWZnS1Cae9o4_msEE1H83Tld5cFtl3Q=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 17520,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAxPfKnfHAnAs0rOqaSwINOxDYJsyj-gPBP0OQ=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 2123,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAzCuCdsGXFCbf4rLBAhjeMMHFFysegG1-UhuA=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 18588,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAzyfBvNU5VU02qSkcq4Oh-UV9fi5WCoouFlLw=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 24662,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAwcTnOLp9VGioPsNXlWlSfh6LgLNyTDVjwAQQ=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 41636,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAzAvn6I90CQDXc2tu3p0uogRhKDR73Lh-vNtQ=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 32049,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAxFcgrr4z2HUpBydA8gKw6BDBDFihtF5RHrUQ=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 22972,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAzsT8X5tAhA79Q7TTROwl_2ma_rEsJ9_-Meqw=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 21381,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAzRQJAUjeZFI02p-1CcDrL9wLLVIhX19vkd1g=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 23908,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAyVsgiMMjmLZQMZ3rfPqJx1P-_GrKbBSsIVOw=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 16760,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAx8SlKLwMmVzpb98vzN_3NN7XAT-0AkAqMGbg=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 2057,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAxU_fyvQmYLR2EtajxU707WVCTWOJTJSXFkBQ=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 21361,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAywkxHrOwWpRIaud0guzZ70fpCYv0UAJ9HpvA=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 5647,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAy2EWNxBNtrh6IYrqFbA-lDi7vMWCMYv-4NGA=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 13533,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAz62Bb80XyoL-84FII_P-v-Bae-NHPxUmuRvg=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 23608,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAxqqiXHbh3YGTH4yymsYmpQTXgEbX-tw0fboA=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    },
    {
        "id": 6647,
        "avatar": "https://yt3.ggpht.com/a-/AN66SAxsFlqKodD9iRRfWpIYlBdkqE8w4YQAGsB4Ew=s240-mo-c-c0xffffffff-rj-k-no",
        "title": "?????",
        "country": "?????",
        "channelType": "?????",
        "videoCount": "?????",
        "subscriberCount": "?????",
        "monthSubscriberCount": "?????",
        "monthSubscriberRate": "??",
        "monthViewCount": "?????",
        "monthViewRate": "??",
        "recentAvgViewCount": "?????",
        "recentAvgEngageRate": "??"
    }
]
/*PM 表示:一切都是後端指使的*/ 


// WEBPACK FOOTER //
// ./src/InfoList/ChannelList.js